const API = 'https://ws-classlist.umanitoba.ca';
const AUTH_API = 'https://vpl-ndkrclprd02.ad.umanitoba.ca';

export const environment = {
  production: true,
  env: 'production', // current environment; Can be 'development', 'testing', 'production', or 'test' for unit testing
  api: API,
  auth: {
    timeout: 5 * 60 * 60 * 1000,
    login_url: `${API}/staff/login`,
    oidc_login_url: `${AUTH_API}/auth/login`,
    oidc_token_url: `${AUTH_API}/auth/token`,
    oidc_logout_url: `${AUTH_API}/auth/logout`,
    me_url: `${API}/staff/me`,
    auth_path: ['/', 'admin', 'auth'],
    success_path: ['/', 'admin'],
  },
  compression: {
    maxSizeMB: 3,
    maxWidthOrHeight: 1500,
    useWebWorker: true,
    initialQuality: .9
  },
  max_range_days: 5,
  mobile_max_width: 768,
  /** file destination at the backend */
  file_storage: {
    /** Name of the multipart form field to process */
    filename: 'single_file',
  },
  swim_program_group_scoring: {
    age: 3,
    swimming_benchmarks: 10,
    swimming_skills: 2,
  }
};
